export enum RegistrationMessageResult {
  Success = 'SUCCESS',
}
